import React, { useState } from 'react';
import { Card } from './ui/card';
import { Badge } from './ui/badge';
import { ChevronDown, ChevronUp } from 'lucide-react';
import '../styles/Projects.css';

const Projects = ({ data }) => {
  const [expandedProject, setExpandedProject] = useState(null);

  const toggleProject = (projectId) => {
    setExpandedProject(expandedProject === projectId ? null : projectId);
  };

  return (
    <section id="projects" className="projects-section">
      <div className="projects-container">
        <div className="section-header">
          <h2 className="section-title">Featured Projects</h2>
          <p className="section-subtitle">
            Case studies showcasing data-driven impact
          </p>
        </div>

        <div className="projects-grid">
          {data.map((project) => {
            const isExpanded = expandedProject === project.id;
            return (
              <Card key={project.id} className="project-card">
                <div className="project-header">
                  <h3 className="project-title">{project.title}</h3>
                </div>

                <div className="project-section">
                  <h4 className="project-section-title">Problem</h4>
                  <p className="project-text">{project.problem}</p>
                </div>

                <div className={`project-details ${isExpanded ? 'expanded' : ''}`}>
                  <div className="project-section">
                    <h4 className="project-section-title">Approach</h4>
                    <ul className="project-list">
                      {project.approach.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="project-section">
                    <h4 className="project-section-title">Technologies</h4>
                    <div className="tech-badges">
                      {project.technologies.map((tech, index) => (
                        <Badge key={index} variant="secondary" className="tech-badge">
                          {tech}
                        </Badge>
                      ))}
                    </div>
                  </div>

                  <div className="project-section">
                    <h4 className="project-section-title">Results</h4>
                    <div className="results-metrics">
                      {project.results.metrics.map((metric, index) => (
                        <div key={index} className="metric-card">
                          <div className="metric-value">{metric.value}</div>
                          <div className="metric-label">{metric.label}</div>
                        </div>
                      ))}
                    </div>
                    <p className="project-impact">{project.results.impact}</p>
                  </div>
                </div>

                <button
                  className="expand-button"
                  onClick={() => toggleProject(project.id)}
                >
                  {isExpanded ? (
                    <>
                      <span>Show Less</span>
                      <ChevronUp className="h-4 w-4" />
                    </>
                  ) : (
                    <>
                      <span>View Full Case Study</span>
                      <ChevronDown className="h-4 w-4" />
                    </>
                  )}
                </button>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Projects;